import { GetLegacyTimelineDetailsRequest } from './getLegacyTimelineDetails';
import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export const getLegacyTimelineExport = createGetEndpoint<GetLegacyTimelineDetailsRequest, Blob>(
	(request) => `/api/v2/timelines/export?${getQueryString(request)}`,
	{
		responseIsBlob: true
	}
);
